import { memo, useCallback } from 'react';

import { type Board } from '@air/api/types';

import { PrivateExtensionsSelect } from '~/components/Filters/ExtensionFilter/components/PrivateExtensionsSelect';
import { type BaseFilterCardProps } from '~/components/Filters/FilterCard';
import { StringArrayFilterCard } from '~/components/Filters/StringArrayFilterCard';
import { type BaseStringSelectProps } from '~/components/StringSelect';

export type PrivateExtensionsFilterCardProps = {
  boardId: Board['id'] | undefined;
  libraryId: string | undefined;
} & BaseFilterCardProps;

export const PrivateExtensionsFilterCard = memo(
  ({ boardId, libraryId, ...props }: PrivateExtensionsFilterCardProps) => {
    const renderExtensionsSelect = useCallback(
      (props: BaseStringSelectProps) => <PrivateExtensionsSelect {...props} boardId={boardId} libraryId={libraryId} />,
      [boardId, libraryId],
    );

    return (
      <StringArrayFilterCard
        filter="extensions"
        filterCardType="extension"
        StringSelect={renderExtensionsSelect}
        {...props}
      />
    );
  },
);

PrivateExtensionsFilterCard.displayName = 'PrivateExtensionsFilterCard';
